import { useDispatch, useSelector } from 'react-redux';
import { WidgetID } from '../../../models/widget.model';
import { RootState } from '../../../store';
import { selectPagination, setPagination } from '../../../store/slices/pagination.slice';
import { useCallback } from 'react';
import { GridPageChangeEvent } from '@progress/kendo-react-grid';
import { PagerTargetEvent } from '@progress/kendo-react-data-tools';

export function useGridWithPaging(id: WidgetID, total: number) {
  const dispatch = useDispatch();
  const paging = useSelector((state: RootState) => selectPagination(state, id));

  const onPageChange = useCallback(
    (event: GridPageChangeEvent) => {
      const targetEvent = event.targetEvent as PagerTargetEvent;
      const take = targetEvent.value === 'All' ? total : event.page.take;
      const paginationValue = {
        id: id,
        skip: event.page.skip,
        take: Number(take),
        total: Number(total),
      };
      dispatch(setPagination(paginationValue));
    },
    [total, dispatch, id]
  );

  return { paging, onPageChange };
}
